import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getPersonalLoanById, getAllAdmins } from "../../../middleware/backend_hepler";
import { AuthContext } from "../../../Context/AuthContext";
import { FaEdit } from 'react-icons/fa';
import { Row, Col, Button } from "react-bootstrap";
import PdfDownloader from "../../../common/PdfDownloader";


const EditPersonalViewModal = ({ isOpen, onClose, loanId }) => {
  const { adminId, adminName, adminRole } = useContext(AuthContext);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    form_id: "",
    created_id: "",
    created_by: "",
    assigned_to: "",
    status: "",
    rejected_reason: "",
    name: "",
    dob: "",
    age: "",
    mobile: "",
    email: "",
    company_type: "",
    net_salary: "",
    is_pf_deducted: "",
    existing_emi_amount: "",
    company_name: "",
    others_company: "",
    address: "",
    state: "",
    city: "",
    pincode: "",
    required_loan_amount: "",
    total_experience: "",
    guarantor_city: "",
    guarantor_state: "",
    guarantor_pincode: "",
    guarantor_mobile: "",
    mother_name: "",
    father_name: "",
    residence_type: "",
    maritalStatus: "",
    spouse_name: "",
    landmark: "",
    present_address_adhaar: "",
    present_address: "",
    present_state: "",
    present_city: "",
    present_pincode: "",
    present_landmark: "",
    office_address: "",
    office_state: "",
    office_city: "",
    office_pincode: "",
    office_landmark: "",
    add_reference: "",
    reference_name: "",
    reference_mobile: "",
    reference_address: "",
    reference_location: "",
    type_your_designation: "",
    bank_name: "",
  });

  useEffect(() => {
    const fetchAgents = async () => {
      if (loanId && isOpen) {
        try {
          const response = await getAllAdmins();
          const filteredAgents = response.filter((admin) => admin.role === "employee");
          setAgents(filteredAgents);
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.error("Error fetching agents:", error);
        }
      }
    };

    fetchAgents();
  }, []);

  useEffect(() => {
    const fetchLoanData = async () => {
      try {
        const loan = await getPersonalLoanById(loanId);
        console.log("Fetched Loan Data:", loan);
        setFormData({
          form_id: loan.form_id || "",
          created_id: loan.created_id || "",
          created_by: loan.created_by || "",
          assigned_to: loan.assigned_to || "",
          status: loan.status || "",
          rejected_reason: loan.rejected_reason || "",
          name: loan.name || "",
          dob: loan.dob || "",
          age: loan.age || "",
          mobile: loan.mobile || "",
          email: loan.email || "",
          mother_name: loan.mother_name || "",
          father_name: loan.father_name || "",
          maritalStatus: loan.maritalStatus || "",
          spouse_name: loan.spouse_name || "",
          landmark: loan.landmark || "",
          address: loan.address || "",
          state: loan.state || "",
          city: loan.city || "",
          pincode: loan.pincode || "",
          required_loan_amount: loan.required_loan_amount || "",
          company_type: loan.company_type || "",
          net_salary: loan.net_salary || "",
          is_pf_deducted: loan.is_pf_deducted || "",
          existing_emi_amount: loan.existing_emi_amount || "",
          company_name: loan.company_name || "",
          others_company: loan.others_company || "",
          total_experience: loan.total_experience || "",
          residence_type: loan.residence_type || "",
          present_address_adhaar: loan.present_address_adhaar || "",
          present_address: loan.present_address || "",
          present_state: loan.present_state || "",
          present_city: loan.present_city || "",
          present_pincode: loan.present_pincode || "",
          present_landmark: loan.present_landmark || "",
          add_reference: loan.add_reference || "",
          reference_name: loan.reference_name || "",
          reference_mobile: loan.reference_mobile || "",
          reference_address: loan.reference_address || "",
          reference_location: loan.reference_location || "",
          office_address: loan.office_address || "",
          office_state: loan.office_state || "",
          office_city: loan.office_city || "",
          office_landmark: loan.office_landmark || "",
          office_pincode: loan.office_pincode || "",
          type_your_designation: loan.type_your_designation || "",
          bank_name: loan.bank_name || "",
        });
      } catch (error) {
        console.error("Error fetching personal loan data:", error);
      }
    };
    fetchLoanData();
  }, [loanId, adminId, adminName]);

 const filteredPdfFormData = [
    {
      title: "Personal Details",
      data: {
        "Loan ID": formData.form_id,
        "Agent ID": formData.created_id,
        "Agent By": formData.created_by,
        "Assign to": formData.assigned_to,
        "Lead Status": formData.status,
        ...(formData.status === "Rejected" && { "Rejected Reason": formData.rejected_reason }),
        "Name": formData.name,
        "Date of Birth": formData.dob,
        "Age": formData.age,
        "Mobile": formData.mobile,
        "Personal Email ID": formData.email,
        "Mother Name": formData.mother_name,
        "Father Name": formData.father_name,
        "Residence Type": formData.residence_type,
        "Marital Status": formData.maritalStatus,
        ...(formData.maritalStatus === "Married" && { "Spouse Name": formData.spouse_name }),
        "Present Staying Address": formData.address,
        "Landmark": formData.landmark,
        "State": formData.state,
        "City": formData.city,
        "Pincode": formData.pincode,
        "Is Present Address as per Aadhaar": formData.present_address_adhaar,
        ...(formData.present_address_adhaar === "No" && {
          "Present Aadhaar Address": formData.present_address,
          "State(Aadhaar)": formData.present_state,
          "City(Aadhaar)": formData.present_city,
          "Pincode(Aadhaar)": formData.present_pincode,
          "Landmark(Aadhaar)": formData.present_landmark,
        }),
      },
    },
    {
      title: "Income Details",
      data: {
        "Required Loan Amount": formData.required_loan_amount,
        "Existing EMI": formData.existing_emi_amount,
        // "Currently Working Company": formData.company_name,
        "Currently Working Company": formData.others_company,
        "Bank Name": formData.bank_name,
        "Company Type": formData.company_type,
        "Type Your Designation": formData.type_your_designation,
        "Net Salary": formData.net_salary,
        "Is PF Deducted?": formData.is_pf_deducted,
        "Total Years of Experience": formData.total_experience,
        "Office Address": formData.office_address,
        "Office Landmark": formData.office_landmark,
        "Office State": formData.office_state,
        "Office City": formData.office_city,
        "Office Pincode": formData.office_pincode,
      },
    },
    {
      title: "Reference Details",
      data: (formData.add_reference === "Relative" || formData.add_reference === "Colleague") ? {
        "Add Reference": formData.add_reference,
        "Name": formData.reference_name,
        "Mobile": formData.reference_mobile,
        "Address": formData.reference_address,
        "Location": formData.reference_location,
      } : {},
    },
  ];

  const handleEditClick = () => {
    navigate(`/edit-personal-loan/${loanId}`);
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay-edit')) {
      onClose();
    }
  };

  const formattedDob = formData.dob
    ? (() => {
        const d = new Date(formData.dob);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      })()
    : "";

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-edit" onClick={handleOverlayClick}>
      <div className="modal-content-edit">
      <h3 className="edit-title">
        <span className="product-title-text">Personal Loan</span>
        <span className="action-icon">
          <FaEdit
            className="edit-loan"
            style={{ cursor: "pointer" }}
            onClick={handleEditClick}
          />
          <PdfDownloader formData={filteredPdfFormData} loanId={loanId} />
        </span>
      </h3>
        <div className="form-content-section">
          <div className="step-sections-personal-details-sections">
            <h4>Personal Details</h4>
            <div className="form-row-step">
              <strong>Loan ID:</strong>
              <div className="value">{formData.form_id}</div>
            </div>
            {adminRole !== "customer"&&(
              <>
                <div className="form-row-step">
                  <strong>Employee ID:</strong>
                  <div className="value">{formData.created_id}</div>
                </div>

                <div className="form-row-step">
                  <strong>Employee:</strong>
                  <div className="value">{formData.created_by}</div>
                </div>
              </>
            )}
            {(adminRole === "admin")&&(
              <div className="form-row-step">
                <strong>Assign to:</strong>
                <div className="value">{formData.assigned_to}</div>
              </div>
            )}
            <div className="form-row-step">
              <strong>Lead Status:</strong>
              <div className="value">{formData.status}</div>
            </div>
            {formData.status === "Rejected" && (
              <div className="form-row-step">
                <strong>Rejected reason:</strong>
                <div className="value">{formData.rejected_reason}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Name:</strong>
              <div className="value">{formData.name}</div>
            </div>

            <div className="form-row-step">
              <strong>Date of Birth:</strong>
              <div className="value">{formattedDob}</div>
            </div>

            <div className="form-row-step">
              <strong>Age:</strong>
              <div className="value">{formData.age}</div>
            </div>

            <div className="form-row-step">
              <strong>Mobile:</strong>
              <div className="value">{formData.mobile}</div>
            </div>

            <div className="form-row-step">
              <strong>Personal Email ID:</strong>
              <div className="value">{formData.email}</div>
            </div>

            <div className="form-row-step">
              <strong>Mother Name:</strong>
              <div className="value">{formData.mother_name}</div>
            </div>

            <div className="form-row-step">
              <strong>Father Name:</strong>
              <div className="value">{formData.father_name}</div>
            </div>

            <div className="form-row-step">
              <strong>Residence Type:</strong>
              <div className="value">{formData.residence_type}</div>
            </div>

            <div className="form-row-step">
              <strong>Marital Status:</strong>
              <div className="value">{formData.maritalStatus}</div>
            </div>

            {formData.maritalStatus === "Married" && (
              <div className="form-row-step">
                <strong>Spouse Name:</strong>
                <div className="value">{formData.spouse_name}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Present Staying Address:</strong>
              <div className="value">{formData.address}</div>
            </div>

            <div className="form-row-step">
              <strong>Landmark:</strong>
              <div className="value">{formData.landmark}</div>
            </div>

            <div className="form-row-step">
              <strong>State:</strong>
              <div className="value">{formData.state}</div>
            </div>

            <div className="form-row-step">
              <strong>City:</strong>
              <div className="value">{formData.city}</div>
            </div>

            <div className="form-row-step">
              <strong>Pincode:</strong>
              <div className="value">{formData.pincode}</div>
            </div>

            <div className="form-row-step">
              <strong>Is your Present Address as per Aadhaar:</strong>
              <div className="value">{formData.present_address_adhaar}</div>
            </div>

            {formData.present_address_adhaar === "No" && (
              <>
                <div className="form-row-step">
                  <strong>Present Aadhaar Address:</strong>
                  <div className="value">{formData.present_address}</div>
                </div>

                <div className="form-row-step">
                  <strong>State:</strong>
                  <div className="value">{formData.present_state}</div>
                </div>

                <div className="form-row-step">
                  <strong>City:</strong>
                  <div className="value">{formData.present_city}</div>
                </div>

                <div className="form-row-step">
                  <strong>Pincode:</strong>
                  <div className="value">{formData.present_pincode}</div>
                </div>

                <div className="form-row-step">
                  <strong>Landmark:</strong>
                  <div className="value">{formData.present_landmark}</div>
                </div>
              </>
            )}

            <h4>Income Details</h4>

            <div className="form-row-step">
              <strong>Required Loan Amount:</strong>
              <div className="value">{formData.required_loan_amount}</div>
            </div>

            <div className="form-row-step">
              <strong>Existing EMI:</strong>
              <div className="value">{formData.existing_emi_amount}</div>
            </div>

            {/* <div className="form-row-step">
              <strong>Currently Working Company:</strong>
              <div className="value">{formData.company_name}</div>
            </div> */}

             <div className="form-row-step">
              <strong>Currently Working Company:</strong>
              <div className="value">{formData. others_company}</div>
            </div>

            {adminRole !== "customer"&&(
              <div className="form-row-step">
                <strong>Bank Name:</strong>
                <div className="value">{formData.bank_name}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Company Type:</strong>
              <div className="value">{formData.company_type}</div>
            </div>

            <div className="form-row-step">
              <strong>Type Your Designation:</strong>
              <div className="value">{formData.type_your_designation}</div>
            </div>

            <div className="form-row-step">
              <strong>Net Salary:</strong>
              <div className="value">{formData.net_salary}</div>
            </div>

            <div className="form-row-step">
              <strong>Is PF Deducted?:</strong>
              <div className="value">{formData.is_pf_deducted}</div>
            </div>

            <div className="form-row-step">
              <strong>Total Years of Experience:</strong>
              <div className="value">{formData.total_experience}</div>
            </div>

            <div className="form-row-step">
              <strong>Office Address:</strong>
              <div className="value">{formData.office_address}</div>
            </div>

            <div className="form-row-step">
              <strong>Office Landmark:</strong>
              <div className="value">{formData.office_landmark}</div>
            </div>

            <div className="form-row-step">
              <strong>Office State:</strong>
              <div className="value">{formData.office_state}</div>
            </div>

            <div className="form-row-step">
              <strong>Office City:</strong>
              <div className="value">{formData.office_city}</div>
            </div>

            <div className="form-row-step">
              <strong>Office Pincode:</strong>
              <div className="value">{formData.office_pincode}</div>
            </div>

            {(formData.add_reference === "Relative" || formData.add_reference === "Colleague") && (
              <>
                <h4>Reference Details</h4>
                <div className="form-row-step">
                  <strong>Add Reference:</strong>
                  <div className="value">{formData.add_reference}</div>
                </div>

                <div className="form-row-step">
                  <strong>Name:</strong>
                  <div className="value">{formData.reference_name}</div>
                </div>

                <div className="form-row-step">
                  <strong>Mobile:</strong>
                  <div className="value">{formData.reference_mobile}</div>
                </div>

                <div className="form-row-step">
                  <strong>Address:</strong>
                  <div className="value">{formData.reference_address}</div>
                </div>

                <div className="form-row-step">
                  <strong>Location:</strong>
                  <div className="value">{formData.reference_location}</div>
                </div>
              </>
            )}
          </div>

          <div className="button-sections">
            <Row>
              <Col className="text-end">
                <Button
                  className="custom-back-button"
                  type="button"
                  onClick={onClose}
                >
                  Close
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditPersonalViewModal;